<div class="wrapper" style="height: calc(100vh - 175px)">
  <div class="abs-center wd-xl">
    <!-- START card-->
    <div class="text-center mb-4">
      <div class="text-lg mb-3">403 Forbidden</div>
      <p class="lead m0">Not authorized to access resource</p>
      <p>
        You are not authorized to access this resource. Please contact the system Administrator if u
        wish to gain access.
      </p>
    </div>
  </div>
</div>
